import { FaqPresenter } from './FaqPresenter';
import { Settings } from '../common/Settings';

const axios = require('axios');

export default class FaqController {    
    constructor() {
        this.model = [];
        this.presenter = new FaqPresenter();
        this.$container = $("#faq");
        this.contactForm = $(".contact_form__container")
    }

    Init() {                    
        axios.get('/Faq/GetAll',
        {
            params: {                
                lang: Settings.language()
            }
        })
        .then((response) => {            
            this.presenter.render(response.data);
            this.model = response.data;                                
        })
        .catch((error) => {        
            console.log(error);
        });

        // axios.get('/Contact/Get',
        // {
        //     params: {                
        //         lang: Settings.language()                
        //     }
        // })
        // .then((response) => {                        
        //     this.contactForm.html(response.data);
        // })
        // .catch((error) => {        
        //     console.log(error);
        // });
    }
}